import { createFileRoute, Navigate, redirect } from '@tanstack/react-router';
import { type ReactElement } from 'react';
import { type z } from 'zod';

import { agentConfigurationSearchSchema } from '@apps/web/components/automations/agent_configuration_search';
import { AutomationListPage } from '@apps/web/components/automations/customer/automation_list_page';
import { useSettingsGates } from '@apps/web/features/settings';

/** Compat for the retired `?automation_id=` detail param. */
export function handleRoutinesBeforeLoad({
    search,
}: {
    readonly search: z.infer<typeof agentConfigurationSearchSchema>;
}): void {
    if (search.automation_id === undefined) {
        return;
    }
    throw redirect({
        to: '/routines/$routineId',
        params: { routineId: search.automation_id },
        search: {},
        replace: true,
    });
}

export const Route = createFileRoute('/_app/(main)/routines/')({
    validateSearch: agentConfigurationSearchSchema,
    beforeLoad: handleRoutinesBeforeLoad,
    head: () => ({
        meta: [{ title: 'Routines | Phoebe' }],
    }),
    component: RoutinesListRoute,
});

function RoutinesListRoute(): ReactElement | null {
    const { organizationId, isLoading, gates } = useSettingsGates();

    if (isLoading) {
        return null;
    }
    if (!gates.canManageOrgSettings || !gates.coordinatorAutomations) {
        return <Navigate to="/home" replace={true} />;
    }
    if (organizationId === null) {
        return null;
    }

    return <AutomationListPage organizationId={organizationId} />;
}
